export const shippingLabelPlaceholders = [
  {
    name: "{FirstName}",
    description: "First name of the contact for consumables that is the closest to the asset",
    disabledTargetSystems: {},
  },
  {
    name: "{LastName}",
    description: "Last name of the contact for consumables that is the closest to the asset",
    disabledTargetSystems: {},
  },
  {
    name: "{MailStop}",
    description: "Mail stop of the contact for consumables that is the closest to the asset",
    disabledTargetSystems: {},
  },
  {
    name: "{EmailAddress}",
    description: "Email address of the contact for consumables that is the closest to the asset",
    disabledTargetSystems: {},
  },
  {
    name: "{PhoneNumber}",
    description: "Primary phone number of the contact for consumables that is the closest to the asset",
    disabledTargetSystems: {},
  },
  {
    name: "{PhoneNumber2}",
    description: "Secondary phone number of the contact for consumables that is the closest to the asset",
    disabledTargetSystems: {},
  },
  {
    name: "{DeptName}",
    description: "Department name",
    disabledTargetSystems: {},
  },
  {
    name: "{LocationGrid}",
    description: "Location grid where the device is located",
    disabledTargetSystems: {},
  },
  {
    name: "{LocationDetail}",
    description: "Additional details for directions to the device's location",
    disabledTargetSystems: {},
  },
  {
    name: "{AreaName}",
    description: "Area name of the group owning the device",
    disabledTargetSystems: {},
  },
  {
    name: "{GroupName}",
    description: "Name of the group owning the device",
    disabledTargetSystems: {},
  },
  {
    name: "{SiteName}",
    description: "Name of the customer site where the device is located",
    disabledTargetSystems: {},
  },
  {
    name: "{BuildingName}",
    description: "Name of the building where the device is located",
    disabledTargetSystems: {},
  },
  {
    name: "{LevelName}",
    description: "Name of the level where the device is located",
    disabledTargetSystems: {},
  },
  {
    name: "{ModelName}",
    description: "Model name of the device",
    disabledTargetSystems: {},
  },
  {
    name: "{FamilyName}",
    description: "Family name of the device",
    disabledTargetSystems: {},
  },
  {
    name: "{ProductNumber}",
    description: "Product number of the device",
    disabledTargetSystems: {},
  },
  {
    name: "{ManufacturerName}",
    description: "Name of the manufacturer of the device",
    disabledTargetSystems: {},
  },
  {
    name: "{AssetNumber}",
    description: "Asset number of the device",
    disabledTargetSystems: {},
  },
  {
    name: "{SerialNumber}",
    description: "Serial number of the device",
    disabledTargetSystems: {},
  },
  {
    name: "{HostName}",
    description: "Hostname of the device",
    disabledTargetSystems: {},
  },
  {
    name: "{IPAddress}",
    description: "IP address of the device",
    disabledTargetSystems: {},
  },
  {
    name: "{PortNumber}",
    description: "Port number of the device",
    disabledTargetSystems: {},
  },
  {
    name: "{CommentText}",
    description: "Comments about the device",
    disabledTargetSystems: {},
  },
  {
    name: "{Custom1}",
    description: "Custom field 1 value of the asset",
    disabledTargetSystems: {},
  },
  {
    name: "{Custom2}",
    description: "Custom field 2 value of the asset",
    disabledTargetSystems: {},
  },
  {
    name: "{Custom3}",
    description: "Custom field 3 value of the asset",
    disabledTargetSystems: {},
  },
  {
    name: "{Custom4}",
    description: "Custom field 4 value of the asset",
    disabledTargetSystems: {},
  },
  {
    name: "{Custom5}",
    description: "Custom field 5 value of the asset",
    disabledTargetSystems: {},
  },
];
